<div class="sidebar-container cb">
  <div class="mobile-only mobile-header">
    <img class="logo" src="assets/cb/images/CB_Icon_Rev.svg" alt="{{ environment.config.title }} Logo">
    <div class="close-icon" (click)="close.emit(null)"><img src="assets/cb/images/Close_Icon.svg" alt="Close menu"></div>
  </div>
  <img class="web-tab-only web-header" src="assets/cb/images/CB_Icon_Rev.svg" alt="{{ environment.config.title }} Logo">
  <div class="mobile-only divider"></div>
  <div class="section">
    <div class="section-heading" (click)="categoryTapped('boxes')">BOXES
      @if (openCategory()!='boxes') {
        <img class="mobile-only" src="assets/cb/images/expand_plus_icon.svg" alt="">
      }
      @if (openCategory()=='boxes') {
        <img class="mobile-only" src="assets/cb/images/expand_minus_icon.svg" alt="">
      }
    </div>
    <div class="section-list" [ngClass]="{'close-section-list': openCategory()!='boxes'}">
      <div class="section-item"><a [routerLink]="['/box-category', {upload: false}]">START BUILDING <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
      <div class="section-item"><a [routerLink]="['/samples']">ORDER SAMPLE <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
    </div>
  </div>
  <div class="divider"></div>
  <div class="section">
    <div class="section-heading" (click)="categoryTapped('account')">ACCOUNT
      @if (openCategory()!='account') {
        <img class="mobile-only" src="assets/cb/images/expand_plus_icon.svg" alt="">
      }
      @if (openCategory()=='account') {
        <img class="mobile-only" src="assets/cb/images/expand_minus_icon.svg" alt="">
      }
    </div>
    <div class="section-list" [ngClass]="{'close-section-list': openCategory()!='account'}">
      @if (user()) {
        <div>
          <div class="section-item"><a [routerLink]="['/account']">ACCOUNT OVERVIEW <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
          <div class="section-item"><a [routerLink]="['/order-history']">ORDER HISTORY <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
          <div class="section-item"><a [routerLink]="['/continue-project']">ONLINE DESIGNS <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
          <div class="section-item"><a [routerLink]="['/box-category', {upload: true}]">OFFLINE DESIGNS <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
          @if (rewardsEnabled) {
            <div class="section-item"><a [routerLink]="['/rewards']">REWARDS <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
          }
          <div (click)="logout(); close.emit(null)" class="section-item"><a>LOG OUT <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
        </div>
      }
      @if (!user()) {
        <div class="section-item"><a [routerLink]="['/login']">LOGIN  <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
      }
    </div>
  </div>
  <div class="divider"></div>
  <div class="section">
    <div class="section-heading" (click)="categoryTapped('resources')">RESOURCES
      @if (openCategory()!='resources') {
        <img class="mobile-only" src="assets/cb/images/expand_plus_icon.svg" alt="">
      }
      @if (openCategory()=='resources') {
        <img class="mobile-only" src="assets/cb/images/expand_minus_icon.svg" alt="">
      }
    </div>
    <div class="section-list" [ngClass]="{'close-section-list': openCategory()!='resources'}">
      <div class="section-item"><a href="https://www.companybox.com/faq/" target="_blank" (click)="close.emit(null)">ARTWORK GUIDELINES <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
      <div class="section-item"><a href="https://www.companybox.com/faq/" target="_blank" (click)="close.emit(null)">SHIPPING POLICIES <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
      <div class="section-item"><a href="https://www.companybox.com/faq/" target="_blank" (click)="close.emit(null)">FAQ <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
      <div class="section-item"><a href="https://www.companybox.com/privacy-policy/" target="_blank" (click)="close.emit(null)">PRIVACY
        POLICY <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
        <div class="section-item"><a href="https://www.companybox.com/terms-and-conditions/" target="_blank" (click)="close.emit(null)">TERMS AND
          CONDITIONS <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a></div>
          <div class="section-item"><a href="https://www.companybox.com/about/contact-us/" target="_blank" (click)="close.emit(null)">CONTACT US <img class="mobile-only" src="assets/cb/images/chevron_right_red.svg" alt=""></a>
        </div>
      </div>
    </div>
    <div class="mobile-only divider" style="margin-bottom: 15px;"></div>

    <a class="mobile-only mobile-button blue" href="tel:+18779263223"><img src="assets/cb/images/call_p_icon.svg" alt="">877.926.3223</a>
    <a class="mobile-only mobile-button blue" [routerLink]="['/samples']">ORDER SAMPLE</a>
    @if (!user()) {
      <a class="mobile-only mobile-button red" [routerLink]="['/login']">LOGIN</a>
    }
    @if (user()) {
      <a class="mobile-only mobile-button red" (click)="logout(); close.emit(null)">LOG OUT</a>
    }

    <div class="mobile-only social-media-group cb">
      <a class="mobile-only social-media-button" href="https://www.facebook.com/companybox/"><img src="assets/cb/images/facebook_icon_red.svg" alt="Facebook"></a>
      <a class="mobile-only social-media-button" href="https://twitter.com/company_box"><img src="assets/cb/images/twitter_icon_red.svg" alt="Twitter"></a>
      <a class="mobile-only social-media-button" href="https://www.instagram.com/companybox/"><img src="assets/cb/images/instagram_icon_red.svg" alt="Instagram"></a>
      <a class="mobile-only social-media-button" href="https://www.linkedin.com/company/companybox%E2%84%A2/"><img src="assets/cb/images/linkedin_icon_red.svg" alt="LinkedIn"></a>
      <a class="mobile-only social-media-button" href="mailto:info@companybox.com"><img src="assets/cb/images/email_icon_red.svg" alt="Email"></a>
    </div>
  </div>

  <ng-template #login>
    <app-login-modal (closeModal)="hide()"></app-login-modal>
  </ng-template>

  <ng-template #terms>
    <app-common-terms></app-common-terms>
  </ng-template>

  <ng-template #privacy_policy>
    <app-common-privacy-policy></app-common-privacy-policy>
  </ng-template>
